import React, { useEffect } from "react";
import { CToast, CToastBody, CToastHeader, CToaster } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilCheckCircle, cilXCircle, cilInfo } from "@coreui/icons";

const AppToast = ({
  visible,
  setVisible,
  type = "info",
  title = "",
  message = "",
  cta = null, // optional: { label: string, onClick: fn }
}) => {
  const getStyles = (toastType) => {
    switch (toastType) {
      case "success":
        return {
          icon: cilCheckCircle,
          style: {
            background: "#f6ffed",
            borderLeft: "6px solid #52c41a",
            color: "#237804",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            minWidth: "300px",
            fontSize: "18px",
          },
        };
      case "error":
        return {
          icon: cilXCircle,
          style: {
            background: "#fff2f0",
            borderLeft: "6px solid #ff4d4f",
            color: "#a8071a",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            minWidth: "300px",
            fontSize: "18px",
          },
        };
      case "info":
      default:
        return {
          icon: cilInfo,
          style: {
            background: "#e6f7ff",
            borderLeft: "6px solid #1890ff",
            color: "#0050b3",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            minWidth: "300px",
            fontSize: "18px",
          },
        };
    }
  };

  const { icon, style } = getStyles(type);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const toastElement = document.getElementById("app-toast");
      if (toastElement && !toastElement.contains(event.target)) {
        setVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [setVisible]);

  return (
    <>
      {/* 🔥 CoreUI Toast Position Override */}
      <style>{`
        .app-toast-container {
          top: 15% !important;
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
          .app-toast-container .toast {
    width: 600px !important;       /* 👈 set desired width */
    max-width: 90vw !important;    /* 👈 responsive on small screens */
  }
      `}</style>

      <CToaster placement="top-center" className="app-toast-container">
        <CToast
          id="app-toast"
          visible={visible}
          autohide={false}
          onClose={() => setVisible(false)}
          style={style}
        >
          <CToastHeader
            closeButton
            style={{
              background: "transparent",
              borderBottom: "none",
            }}
          >
            <CIcon
              icon={icon}
              className="me-2"
              style={{ color: style.color }}
            />
            <strong
              className="me-auto"
              style={{ color: style.color, fontSize: "24px", padding: "8px" }}
            >
              {title || type.toUpperCase()}
            </strong>
          </CToastHeader>

          <CToastBody
            style={{
              color: style.color,
              fontSize: "20px",
              padding: "20px",
            }}
          >
            {cta ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <span>{message}</span>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    onClick={() => {
                      cta.onClick();
                      setVisible(false);
                    }}
                    style={{
                      flexShrink: 0,
                      background: style.color,
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 700,
                      padding: "8px 16px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {cta.label} →
                  </button>
                </div>
              </div>
            ) : (
              message
            )}
          </CToastBody>
        </CToast>
      </CToaster>
    </>
  );
};

export default React.memo(AppToast);
